import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Celebration";

const Celebration = () => {
  const projectId = "PRJ00072";
  const title = "Celebration Gardens";

  const mapConfig = {
    minZoom: 13,
    zoom: 15,
    bounds: [
      [40.7232, -74.0264],
      [40.71, -74],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/uncategorized/celebrations-gardens-phase-2/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSeq-h_ydPVfvofXJj1FNvHBRtB_f7soDmVfM2Bvquy4H7L6VA/viewform"
    />
  );
};

export default Celebration;
